<template>
  <div class="user-avator-dropdown ">

    <Dropdown @on-click="handleClick">
      <Badge>
        <Avatar :src="head_img" size="25"/>
        <span style="margin-left: 5px;position: relative;top: 2px">{{ nickname }}</span>
      </Badge>
      <Icon :size="18" type="md-arrow-dropdown"></Icon>
      <DropdownMenu slot="list">
        <!-- <DropdownItem name="workbench">工作台</DropdownItem> -->
        <DropdownItem name="user_center">个人资料</DropdownItem>
        <DropdownItem name="user_security">账户安全</DropdownItem>
        <DropdownItem name="logout">退出登录</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>

<script>
import './user.less'
import { mapActions } from 'vuex'

export default {
  name: 'User',
  data () {
    return {
      nickname: '',
      head_img: ''
    }
  },
  created: function () {
    console.log(this.$store.state.userInfo)
    this.nickname = this.$store.state.userInfo.nickname
    this.head_img = this.$store.state.userInfo.head_img
    // `this` 指向 vm 实例
  },
  props: {
    userAvator: {
      type: String,
      default: ''
    }
  },
  methods: {
    logout () {
      this.$store.commit('logout')
      this.$router.push('/login')
    },
    handleClick (name) {
      switch (name) {
        case 'logout':
          this.logout()
          break
        case 'workbench':
          this.$router.push({
            name: 'workbench'
          })
          break
        case 'user_center':
          this.$router.push({
            name: 'user_center'
          })
          break
        case 'user_security':
          this.$router.push({
            name: 'user_security'
          })
          break
      }
    }
  }
}
</script>
